import localReducer from './reducer'
import localSagas from './sagas'

const countriesModule = {
  id: 'countries',
  reducerMap: { countries: localReducer },
  sagas: localSagas,
}

export default countriesModule
